import React from 'react';
import { useT } from '../../i18n/LanguageContext';

export default function DistributorPreviewNotice() {
  const t = useT();
  return (
    <aside className="me-dw-subpanel px-5 py-4" aria-label={t('Read-only preview')}>
      <strong className="text-[#153d48]">{t('Read-only preview')}</strong>
      <p className="mt-1 text-sm text-slate-600">
        {t(
          'Browse this distributor workspace. Creating orders and changing accounts or settings are disabled.'
        )}
      </p>
    </aside>
  );
}
